import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from './ui/dropdown-menu';
import { User, Package, LogOut, Settings, ShieldCheck } from 'lucide-react';

const initials = (name) => (name || '').split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase() || 'U';

const UserMenu = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;

  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 px-2 pr-3 h-10 rounded-full bg-white border border-neutral-200 hover:border-[#8247E5] hover:bg-violet-50 transition-colors">
          {user.picture ? (
            <img src={user.picture} alt={user.name} className="w-7 h-7 rounded-full object-cover" />
          ) : (
            <div className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-semibold" style={{ background: 'linear-gradient(135deg, #8247E5, #A855F7)' }}>
              {initials(user.name)}
            </div>
          )}
          <span className="text-sm font-medium text-neutral-800 max-w-[100px] truncate">{user.name.split(' ')[0]}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="font-normal">
          <div className="flex items-center gap-3 py-1">
            {user.picture ? (
              <img src={user.picture} alt={user.name} className="w-9 h-9 rounded-full object-cover" />
            ) : (
              <div className="w-9 h-9 rounded-full flex items-center justify-center text-white text-sm font-semibold" style={{ background: 'linear-gradient(135deg, #8247E5, #A855F7)' }}>
                {initials(user.name)}
              </div>
            )}
            <div className="min-w-0">
              <div className="font-semibold text-sm truncate">{user.name}</div>
              <div className="text-xs text-neutral-500 truncate">{user.email}</div>
            </div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/dashboard" className="cursor-pointer"><User className="w-4 h-4 mr-2" /> Dashboard</Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/dashboard/orders" className="cursor-pointer"><Package className="w-4 h-4 mr-2" /> My orders</Link>
        </DropdownMenuItem>
        {user.is_admin && (
          <DropdownMenuItem asChild>
            <Link to="/admin" className="cursor-pointer text-[#8247E5] focus:text-[#8247E5] focus:bg-violet-50">
              <ShieldCheck className="w-4 h-4 mr-2" /> Admin dashboard
            </Link>
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="text-rose-600 focus:text-rose-700 focus:bg-rose-50 cursor-pointer">
          <LogOut className="w-4 h-4 mr-2" /> Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserMenu;
